<div bsModal #modal="bs-modal" class="modal fade" tabindex="-1" role="dialog" aria-hidden="true">
    <div class="modal-dialog" [ngClass]="modalClass" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <button type="button" class="close" (click)="modal.hide()" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
                <h4 class="modal-title">{{title}}</h4>
            </div>
            <div class="modal-body">
                {{content}}
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-secondary" (click)="modal.hide()">{{closeButton || ('common.close' | transloco)}}</button>
                <button type="button" class="btn btn-primary" (click)="confirm()">{{confirmButton || ('common.save' | transloco)}}</button>
            </div>
        </div>
        <!-- /.modal-content -->
    </div>
    <!-- /.modal-dialog -->
</div>